import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchReclamations, fetchReclamationsMagasin, setRechercheCritereFiltre, setRechercheCritereCodeDepot, setRechercheCritereCodeAgence } from 'store/reclamation/reclamationsActions';


import ReclamationsDrawerListItem from './ReclamationsDrawerListItem';

import ToutesIcon from '@mui/icons-material/List';
import MaSelectionIcon from '@mui/icons-material/Star';
import CommentairesIcon from '@mui/icons-material/QuestionAnswer';
import ClotureesIcon from '@mui/icons-material/Done';
import AVerifierIcon from '@mui/icons-material/Event';
import ARelancerIcon from '@mui/icons-material/Replay';
import MagasinIcon from '@mui/icons-material/Business';


import { ReclamationFiltre } from 'constants.js';
import { Profils } from 'constants.js';

import localStorageHelper from 'utils/localStorageHelper';
import { sansDepotMagasin } from 'utils/depotHelper';


const titres = [
    'Tous',
    'Ma sélection',
    'Commentaires',
    'Clôturés',
    'A vérifier',
    'Retour Plateforme',
    'A relancer',
];

const icons = [
    <ToutesIcon />,      // eslint-disable-line react/jsx-key
    <MaSelectionIcon />, // eslint-disable-line react/jsx-key
    <CommentairesIcon />,// eslint-disable-line react/jsx-key
    <ClotureesIcon />,   // eslint-disable-line react/jsx-key
    <AVerifierIcon />,   // eslint-disable-line react/jsx-key
    <MagasinIcon />,     // eslint-disable-line react/jsx-key
    <ARelancerIcon />,   // eslint-disable-line react/jsx-key
]; 

class ReclamationsDrawerListItemContainer extends React.Component {


    handleClick = async () => {

        const { utilisateur } = this.props;

        if (!this.props.selected) {
            await this.props.setRechercheCritereFiltre(this.props.filtre);

            await this.props.setRechercheCritereCodeDepot('');
            await this.props.setRechercheCritereCodeAgence('');


            if (this.props.filtre === ReclamationFiltre.RetourPlateforme) {

                let codeDepot = '';
                if (sansDepotMagasin(utilisateur)) {
                    if (utilisateur.depots && utilisateur.depots.length === 1) {
                        codeDepot = utilisateur.depots[0].code;
                    }
                }
                else {
                    codeDepot = utilisateur.depot.code;
                }
                await this.props.setRechercheCritereCodeDepot(codeDepot);
                await this.props.fetchReclamationsMagasin();
            }
            else {
                if (this.props.filtre === ReclamationFiltre.Toutes)
                {
                    if (utilisateur.codePoste === Profils.Magasinier || utilisateur.codePoste === Profils.Sedentaire)
                    {
                        await this.props.setRechercheCritereCodeAgence(utilisateur.codeAgence);
                    }
                }
                await this.props.fetchReclamations();
            }
        }
    }

    render() {
        const { selected, expanded, filtre, anchor } = this.props;


        let href = `/reclamations#${anchor}`;


        return <ReclamationsDrawerListItem selected={selected} expanded={expanded} onClick={this.handleClick} title={titres[filtre]} icon={icons[filtre]} href={href}/>;
    }
}


const mapStateToProps = state => ({
    utilisateur: JSON.parse(localStorage.getItem('utilisateur'))
});

const mapDispatchToProps = dispatch => ({
    setRechercheCritereFiltre: (filtre) => dispatch(setRechercheCritereFiltre(filtre)),
    setRechercheCritereCodeDepot: codeDepot => dispatch(setRechercheCritereCodeDepot(codeDepot)),
    setRechercheCritereCodeAgence: codeAgence => dispatch(setRechercheCritereCodeAgence(codeAgence)),
    fetchReclamations: () => dispatch(fetchReclamations()),
    fetchReclamationsMagasin: () => dispatch(fetchReclamationsMagasin()),
});

ReclamationsDrawerListItemContainer.propTypes = {
    selected: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    filtre: PropTypes.number.isRequired,
    anchor: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReclamationsDrawerListItemContainer);